import Vue from "vue";
import vuetify from "../vuetify.js";
import depsloader from "../depsloader";
import ContactFinanzierungApp from "../components/contact/ContactFinanzierungApp";

export default function() {
  const element = document.querySelector("#vue-finanzierung");

  if (element) {
    depsloader.load("vue-i18n").then((vueI18n) => {
      Vue.use(vueI18n.VueI18n);

      new Vue({
        el: element,

        components: {
          ContactFinanzierungApp
        },

        vuetify,
        i18n: new vueI18n.VueI18n(vueI18n.options),

        render: h => h(ContactFinanzierungApp)
      })
    });
  }
}
